// @flow

import React, { Component } from 'react'

import './ContentPost.css'
import Loading from '../Icons/loading.gif'
import { numberedDateLined } from '../timeutils'
import bellIcon from '../Icons/icon-bell-grey.svg'

type Props = {
  title: string,
  date: string,
  thumbnailUrl: string,
  from: string
}

/**
  * Display for content post
  * @class
  * @extends Component
*/
class ContentPost extends Component<Props> {
  /** render function */
  render () {
    if (this.props.title === 'Loading') {
      return <img src={Loading} alt='Loading' />
    } else if (!this.props.thumbnailUrl && this.props.from === 'ALERT') {
      return (
        <div className='ContentResults box'>
          <h4>
            <span><img src={bellIcon} alt={bellIcon} /></span>
            {this.props.title}
          </h4>
          <span>
            <p>Date Posted</p>
            <p>{numberedDateLined(this.props.date)}</p>
          </span>
        </div>
      )
    } else if (!this.props.thumbnailUrl) {
      return (
        <div className='ContentResults box'>
          <h4>
            {this.props.title}
          </h4>
          <span>
            <p>Date Posted</p>
            <p>{numberedDateLined(this.props.date)}</p>
          </span>
        </div>
      )
    } else {
      return (
        <div className='ContentResults box'>
          <h4>
            <img className='custom-icon' src={this.props.thumbnailUrl} alt='' />
            {this.props.title}
          </h4>
          <span>
            <p>Date Posted</p>
            <p>{numberedDateLined(this.props.date)}</p>
          </span>
        </div>
      )
    }
  }
}

export default ContentPost
